// Compliance alerts are the one bell kind that also pops a side toast while the
// window is in view: they are rare, statutory, and easy to miss. Remembered per
// tab so a bell reload never repeats one. Twin of hrpayroll's
// useNotificationSocket.
import { toast } from 'sonner';

const TOASTED_KEY = 'notif:complianceToasted';

interface ComplianceAlert {
  id: string;
  task_id: string;
  title: string;
  body?: string | null;
  is_read?: boolean;
}

export const isComplianceAlert = (n: { task_id?: string | null }) => !!n.task_id && n.task_id.startsWith('compliance:');

function toasted(): string[] {
  try {
    return JSON.parse(window.sessionStorage.getItem(TOASTED_KEY) || '[]');
  } catch {
    return [];
  }
}

function remember(ids: string[]) {
  try {
    window.sessionStorage.setItem(TOASTED_KEY, JSON.stringify([...toasted(), ...ids]));
  } catch {
    /* private window: at worst a reload repeats the toast */
  }
}

function show(title: string, description: string, onOpen: () => void) {
  toast.warning(title, { description, duration: 10000, action: { label: 'Open', onClick: onOpen } });
}

export function liveComplianceToast(n: ComplianceAlert, onOpen: () => void) {
  if (!isComplianceAlert(n) || document.visibilityState !== 'visible') return;
  remember([n.id]);
  show(n.title, n.body || '', onOpen);
}

// Alerts raised while this person was away got no live frame, so the bell's
// first load announces them: one toast, however many there are.
export function announceUnreadComplianceAlerts(items: ComplianceAlert[], onOpen: () => void) {
  const seen = new Set(toasted());
  const fresh = items.filter((n) => isComplianceAlert(n) && !n.is_read && !seen.has(n.id));
  if (!fresh.length) return;
  remember(fresh.map((n) => n.id));
  if (fresh.length === 1) show(fresh[0].title, fresh[0].body || '', onOpen);
  else show(`${fresh.length} compliance alerts`, 'Open the Compliance Checker to see what needs attention.', onOpen);
}
